module.exports = __webpack_public_path__ + "img/aboutUs5.8f49f00.png";